import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Divider,
  Stack,
} from '@mui/material';
import type { BackupJob, Provider, RestoreJob } from '@repo/api-gw-sdk';
import { useState } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@/components/accordion';
import { CloudProviderCircle } from '@/components/cloudProviderIndicator';
import { useFields } from '@/components/table/hooks';
import type { FilterProperty } from '@/types/advanceFilter';

import { JobSummaryContentWrapper } from './jobSummaryContentWrapper';

export const OperationSummary = ({
  job,
  fromTitle,
  fromFields,
  toTitle,
  toFields,
  fromCloudProvider,
  toCloudProvider,
}: {
  job: BackupJob | RestoreJob;
  fromTitle: string;
  fromFields: FilterProperty[];
  toTitle: string;
  toFields: FilterProperty[];
  fromCloudProvider?: Provider;
  toCloudProvider?: Provider;
}) => {
  const [fromOpen, setFromOpen] = useState(true);
  const [toOpen, setToOpen] = useState(true);
  const filteredFromFields = useFields(fromFields, job);
  const filteredToFields = useFields(toFields, job);

  return (
    <MuiAccordion disableGutters defaultExpanded>
      <MuiAccordionSummary data-testid='operation-summary'>
        Operation summary
      </MuiAccordionSummary>
      <MuiAccordionDetails sx={{ padding: '0px' }}>
        <Accordion
          sx={{ padding: '16px 40px' }}
          expanded={fromOpen}
          onChange={() => setFromOpen(!fromOpen)}
        >
          <AccordionSummary>
            <Stack
              width='100%'
              direction='row'
              justifyContent='space-between'
              alignItems='center'
            >
              {fromTitle}
              {!fromOpen && fromCloudProvider && (
                <CloudProviderCircle cloudProvider={fromCloudProvider} />
              )}
            </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ paddingRight: '0px' }}>
            <JobSummaryContentWrapper
              cloudProvider={fromCloudProvider}
              fields={filteredFromFields}
            />
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion
          sx={{ padding: '16px 40px' }}
          expanded={toOpen}
          onChange={() => setToOpen(!toOpen)}
        >
          <AccordionSummary>
            <Stack
              width='100%'
              direction='row'
              justifyContent='space-between'
              alignItems='center'
            >
              {toTitle}
              {!toOpen && toCloudProvider && (
                <CloudProviderCircle cloudProvider={toCloudProvider} />
              )}
            </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ paddingRight: '0px' }}>
            <JobSummaryContentWrapper
              cloudProvider={toCloudProvider}
              fields={filteredToFields}
            />
          </AccordionDetails>
        </Accordion>
        <Divider />
      </MuiAccordionDetails>
    </MuiAccordion>
  );
};
